import type { DownloadTreeNode } from '~/types/download'
import { computed } from 'vue'

function isNodeSelectable(node: DownloadTreeNode) {
  if (node.selectable !== undefined) {
    return node.selectable
  }
  return node.ezMainNodeId !== undefined
}

export function useDescendants(tocItem: DownloadTreeNode, renderLeafNodes: boolean) {
  function collectRenderableAvailableDescendantIds(node: DownloadTreeNode, out: DownloadTreeNode[] = []): DownloadTreeNode[] {
    const descendants: DownloadTreeNode[] = Array.isArray(node.children) ? node.children : []
    for (const desc of descendants) {
      const descHasChildren = Array.isArray(desc.children) && desc.children.length > 0
      const descRenderable = renderLeafNodes || descHasChildren
      if (descRenderable && desc.id && isNodeSelectable(desc)) {
        out.push(desc)
      }
      if (descHasChildren) {
        collectRenderableAvailableDescendantIds(desc, out)
      }
    }
    return out
  }

  const descendantIds = computed(() => collectRenderableAvailableDescendantIds(tocItem, []))

  return {
    descendantIds,
  }
}
